import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import eventTypeService from '../services/eventTypeService';

const eventTypesCollectionName = 'event_types';

export const useEventType = () => {
  return useQuery({
    queryKey: [eventTypesCollectionName],
    queryFn: () => eventTypeService.getAll(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useAddEventType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: eventTypeService.add,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [eventTypesCollectionName] });
    },
  }); 
};

export const useEditEventType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: eventTypeService.edit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [eventTypesCollectionName] });
    },
  });
};

export const useDeleteEventType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: eventTypeService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [eventTypesCollectionName] });
    },
  }); 
};

export const useEventTypeNameById = (eventTypeId) => {
  return useQuery({
    queryKey: [eventTypesCollectionName, eventTypeId],
    queryFn: () => eventTypeService.getNameById(eventTypeId),
    enabled: !!eventTypeId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  }); 
}

export const useEventTypeById = (eventTypeId) => {
  return useQuery({
    queryKey: [eventTypesCollectionName, 'full', eventTypeId],
    queryFn: () => eventTypeService.getById(eventTypeId),
    enabled: !!eventTypeId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  }); 
}